import gql from "graphql-tag";

// fragment
export const GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT = gql`
    fragment greenhouseDepartmentSection on GreenhouseDepartmentSectionNode {
        id
        isActive
        name
        layoutX
        layoutY
        width
        height
        spaceM2
        usedSpaceM2
        usedRate
        greenhouseDepartment {
            id
            name
            layoutX
            layoutY
            width
            height
            totalSpaceM2
            totalUsedSpaceM2
            totalUsedRate
            greenhouse {
                id
                name
            }
        }
        growthTaskPhaseSet(
            isCurrentPhase: true
            growthTask_TotalInventory_Gt: 0
            orderBy: "phaseNo"
        ) {
            edges {
                node {
                    id
                    phaseNo
                    startDate
                    endDate
                    numDays
                    numPlantsPerM2
                    spaceM2
                    isSalesPhase
                    isCurrentPhase
                    remindedDate
                    confirmedDate
                    growthTask {
                        id
                        numPhases
                        totalGrowthDays
                        growthStartDate
                        growthEndDate
                        maxSalesDays
                        salesStartDate
                        salesEndDate
                        lockedDate
                        lockedComment
                        lockedForCustomer {
                            id
                            name
                        }
                        closedDate
                        closedReason
                        plant {
                            id
                            name
                            plantTagSet {
                                edges {
                                    node {
                                        id
                                        tag {
                                            id
                                            tag
                                            orderId
                                        }
                                    }
                                }
                            }
                        }
                        color {
                            id
                            color
                        }
                        potSize {
                            id
                            potSizeCm
                        }
                        environment {
                            id
                            environment
                        }
                        tag {
                            id
                            tag
                        }
                        plantGrowthTemplate {
                            id
                            name
                        }
                        supplier {
                            id
                            name
                        }
                        supplierOrderNo
                        note
                        totalQuantity
                        totalInventory
                        growthTaskPhaseSet {
                            edges {
                                node {
                                    id
                                    phaseNo
                                    startDate
                                    endDate
                                    numDays
                                    numPlantsPerM2
                                    spaceM2
                                    isSalesPhase
                                    isCurrentPhase
                                    remindedDate
                                    confirmedDate
                                    greenhouseDepartmentSection {
                                        id
                                        name
                                        greenhouseDepartment {
                                            id
                                            name
                                        }
                                    }
                                }
                            }
                        }
                        createdAt
                    }
                }
            }
        }
    }
`;

// all query
export const GREENHOUSE_DEPARTMENT_SECTIONS_QUERY = gql`
    query {
        greenhouseDepartmentSections {
            edges {
                cursor
                node {
                    ...greenhouseDepartmentSection
                }
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT}
`;

// single query
export const SINGLE_GREENHOUSE_DEPARTMENT_SECTION_QUERY = gql`
    query greenhouseDepartmentSection($id: ID!) {
        greenhouseDepartmentSection(id: $id) {
            ...greenhouseDepartmentSection
        }
    }
    ${GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT}
`;

// create
export const CREATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION = gql`
    mutation createGreenhouseDepartmentSection(
        $input: CreateGreenhouseDepartmentSectionInput!
    ) {
        createGreenhouseDepartmentSection(input: $input) {
            greenhouseDepartmentSection {
                ...greenhouseDepartmentSection
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT}
`;

// update
export const UPDATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION = gql`
    mutation updateGreenhouseDepartmentSection(
        $input: UpdateGreenhouseDepartmentSectionInput!
    ) {
        updateGreenhouseDepartmentSection(input: $input) {
            greenhouseDepartmentSection {
                ...greenhouseDepartmentSection
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT}
`;

// delete
export const DELETE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION = gql`
    mutation deleteGreenhouseDepartmentSection(
        $input: DeleteGreenhouseDepartmentSectionInput!
    ) {
        deleteGreenhouseDepartmentSection(input: $input) {
            greenhouseDepartmentSection {
                ...greenhouseDepartmentSection
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_SECTION_FRAGMENT}
`;
